import { createContext } from 'react';
import { InboxMessagesContextProps } from './InboxMessages.types';

const InboxMessagesContext =
  // @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  createContext<InboxMessagesContextProps>(undefined);

export default InboxMessagesContext;
